import { Button, Tooltip } from '@fluentui/react-components';
import { useTranslation } from '../../i18n';
import { LANGUAGE_ENDONYM, type UiLanguage } from '../../i18n/language';
import { useUiLanguage } from '../../i18n/useUiLanguage';

/**
 * The header's EN / ES switch (statetax pattern). It shows the language the UI is in; its name
 * says where it goes, in that language's own word ("Switch to Español", "Cambiar a English"), so it
 * reads right to someone who does not read the current one.
 */
export default function LanguageToggle({ className }: { className?: string }) {
  const { t } = useTranslation();
  const { language, setLanguage } = useUiLanguage();
  const next: UiLanguage = language === 'es' ? 'en' : 'es';
  const label = t('header.language.switchTo', { language: LANGUAGE_ENDONYM[next] });

  return (
    <Tooltip content={label} relationship="label">
      <Button appearance="subtle" className={className} onClick={() => setLanguage(next)}>
        {t('header.language.code')}
      </Button>
    </Tooltip>
  );
}
